// extracted by mini-css-extract-plugin
module.exports = {"base":"PointsList_base__IUuSL","label":"PointsList_label__mw0S3","numbered-list-container":"PointsList_numbered-list-container__AViB8"};